import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Individual.css";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";
// import SideNav from "./SideNav"; 

const MobileRecharge = () => {
  const [activeTab, setActiveTab] = useState('prepaid'); 
  const [showTracker, setShowTracker] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPlans, setShowPlans] = useState(false);

  const plans = [
    { id: 1, amount: 199, data: "1.5GB/day", validity: "28 Days" },
    { id: 2, amount: 399, data: "2GB/day", validity: "56 Days" },
    { id: 3, amount: 599, data: "3GB/day", validity: "84 Days" },
    { id: 4, amount: 599, data: "3GB/day", validity: "84 Days" },
    { id: 5, amount: 599, data: "3GB/day", validity: "84 Days" },
    { id: 6, amount: 599, data: "3GB/day", validity: "84 Days" },
    { id: 7, amount: 299, data: "2GB/day", validity: "28 Days" },
    { id: 8, amount: 499, data: "2GB/day", validity: "56 Days" },
  ];

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setShowPlans(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedPlan(null);
    setShowPlans(false);
    setShowTracker(false);
  };

  const RechargeForm = ({ rechargeType }) => (
    <div className="card p-4 shadow mb-5 recharge-box mt-4" style={{ backgroundColor: '#fff', borderRadius: '10px' }}>
      <div className="mb-4">
        <ul className="nav nav-tabs d-flex justify-content-between" style={{ borderBottom: '2px solid #e9ecef' }}>
  <li className="nav-item">
    <button
      className={`nav-link ${activeTab === 'prepaid' ? 'active' : ''}`}
      onClick={() => handleTabChange('prepaid')}
      style={{
        fontFamily: 'poppins',
        fontWeight: '600',
        color: activeTab === 'prepaid' ? '#0d6efd' : '#6c757d',
        borderBottom: activeTab === 'prepaid' ? '2px solid #0d6efd' : 'none',
        backgroundColor: 'transparent',
        border: 'none'
      }}
    >
      Prepaid
    </button>
  </li>
  <li className="nav-item ">
    <button
      className={`nav-link ${activeTab === 'postpaid' ? 'active' : ''}`}
      onClick={() => handleTabChange('postpaid')}
      style={{
        fontFamily: 'poppins',
        fontWeight: '600',
        color: activeTab === 'postpaid' ? '#0d6efd' : '#6c757d',
        borderBottom: activeTab === 'postpaid' ? '2px solid #0d6efd' : 'none',
        backgroundColor: 'transparent',
        border: 'none'
      }}
    >
      Postpaid
    </button>
  </li>
</ul>

      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">Mobile Number</label>
          <input
            type="tel"
            className="form-control"
            placeholder="Enter your mobile number"
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">Operator</label>
          <input
            type="text"
            className="form-control"
            list="operators"
            placeholder="Enter your operator"
          />
          <datalist id="operators">
            <option value="Airtel" />
            <option value="BSNL" />
            <option value="Jio" />
            <option value="VI" />
          </datalist>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">Circle</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your circle"
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label fw-semibold">Amount</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter your amount"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-3">
          <label className="form-label fw-semibold">Select Plan</label>
          <div style={{ position: "relative" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Data (₹)"
              value={selectedPlan ? `₹${selectedPlan.amount} - ${selectedPlan.data}` : ""}
              readOnly
              onClick={() => setShowPlans(!showPlans)}
              style={{ paddingRight: "2.5rem", cursor: "pointer" }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                fontSize: "1rem",
                color: "#888",
              }}
            >
              ▼
            </span>
          </div>

          {showPlans && (
            <div
              className="border rounded bg-white shadow p-2 position-absolute w-100"
              style={{
                zIndex: 5,
                maxHeight: "300px",
                overflowY: "auto",
                top: "-20%",
                marginTop: "5px"
              }}
            >
              <div className="d-flex fw-bold border-bottom py-2 gap-2">
                <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>ID</div>
                <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>Amount</div>
                <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>Data</div>
                <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>Validity</div>
                <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>Action</div>
              </div>

              {plans.map((plan) => (
                <div
                  key={plan.id}
                  className="d-flex align-items-center py-2 border-bottom" 
                >
                  <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>{plan.id}</div>
                  <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>₹{plan.amount}</div>
                  <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>{plan.data}</div>
                  <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>{plan.validity}</div>
                  <div className="flex-fill text-center" style={{fontFamily:"poppins"}}>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handlePlanSelect(plan)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="d-grid mb-4">
        <button
          className="btn btn-primary"
          style={{ fontFamily: "poppins", padding: "8px", borderRadius: "8px" }}
        >
          Process Recharge
        </button>
      </div>

      <div className="mt-0" style={{ fontFamily: "poppins" }}>
        <span className="text-muted">Status Pending?</span>
        <br />
        <button
          className="btn btn-link text-decoration-none text-primary fw-semibold d-inline-flex align-items-center gap-1 p-0 mt-1"
          onClick={() => setShowTracker(!showTracker)}
        >
          Track Your Status now{" "}
          <span style={{ fontSize: "1.2em" }}>→</span>
        </button>

        {showTracker && (
          <div className="card p-3 mt-3 shadow-sm" style={{ backgroundColor: " #f8f9fa" }}>
            <label className="form-label">Mobile No / Amount</label>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Enter Number To Track Your Status"
            />
            <button
              className="btn btn-outline-primary"
              style={{ fontFamily: "poppins" }}
            >
              Track Now
            </button>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="radial-bg"></div>
      <section
        className="insurance-service position-relative overflow-hidden"
        style={{ zIndex: 1 }}
      >
        <div className="container"> 
          <div className="row">
            {/* <div className="col-lg-3  d-none d-lg-block">
              <div style={{ position: 'relative', height: '100%' }}>
              <SideNav />
            </div>
            </div> */}
            <div className="col-12">
              <div
                className="row justify-content-center text-center"
                // style={{ minHeight: "30vh" }}
              >
                <div className="col-12">
                  <h2 className="fw-semibold recharge-title">
                    {activeTab === 'prepaid' ? '' : ''} Mobile Recharge
                  </h2>
                </div>
              </div>

              <div className="container recharge-box mt-4">
                <div className="row justify-content-center align-items-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <RechargeForm rechargeType={activeTab} />
                  </div>
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "19rem",
                    background: "linear-gradient(to top, #F5F2FF, transparent)",
                    zIndex: "-1",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Explore />
      <Footer />
    </>
  );
};

export default MobileRecharge;